import {Component, OnInit} from '@angular/core';
import {AsaasWebhookTestService} from './asaas-webhook-test.service';
import {MemberService} from '../services/member.service';
import {AsaasService} from '../services/asaas.service';
import {CryptoV2Service} from '../services/crypto-v2.service';
import {PublishService} from '../services/publish.service';
import {AuthService} from '../services/auth.service';
import {SitePublicService} from '../services/site-public.service';
import {EventPublishService} from '../services/event-publish.service';
import {Subject, takeUntil, firstValueFrom, lastValueFrom} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {CalableMemberService} from '../services/calable-member.service';
import {SpinnerService} from '../shared/waiting/spinner.service';
import {OrderedService} from '../services/ordered.service';
import {AngularFireFunctions} from '@angular/fire/compat/functions';

@Component({
  selector: 'app-lab-page',
  templateUrl: './lab-page.component.html',
  styleUrls: [ './lab-page.component.scss' ]
})
export class LabPageComponent implements OnInit {

  public client: any;
  public data: string;

  private destroy$ = new Subject<void>();

  public members: any[] = [];

  constructor (
    private _orderedService: OrderedService,
    private _spinnerService: SpinnerService,
    private _calableMemberService: CalableMemberService,
    private _http: HttpClient,
    private _asaasService: AsaasService,
    private _webhookDevService: AsaasWebhookTestService,
    private _memberService: MemberService,
    private _cryptoV2Service: CryptoV2Service,
    private _publishService: PublishService,
    private _authService: AuthService,
    private _sitePublicService: SitePublicService,
    public _eventPublishService: EventPublishService,
    private ff: AngularFireFunctions


  ) { }

  ngOnInit () {
    this.loadMembers();
  }

  ngOnDestroy () {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async callWebhookCielo (): Promise<any> {
    // APENAS EXECUTA EM SANDBOX - cieloWebhook_v1_dev
    const URL_CIELO_WEBHOOK = 'https://us-central1-sbccv-proj.cloudfunctions.net/cieloWebhook_v1_dev';

    const headers = {
      'Content-Type': 'application/json',
    };

    const payload = {
      "PaymentId": "dd8a32d3-3c92-48e8-b41e-0cb0b878dbd9",
      "ChangeType": 1
    }

    try {
      const response: any = await firstValueFrom(
        this._http.post(URL_CIELO_WEBHOOK, payload, {headers, responseType: 'text'})
      );
      console.log("response:", response);
      return response;
    } catch (error) {
      console.log('Erro em callWebhookCielo status:', error.status);
      console.log('Erro em callWebhookCielo message:', error.message);
      console.log('Erro em callWebhookCielo error:', error.error);
      return error.status;
    }
  }

  async gerarRecibo () {

    const orderId = "CkqBcbng7c92m58oJgC6";
    const wait = this._spinnerService.show();
    const dadosFuncao = await this._calableMemberService.requestReceipt_2026(orderId)
    console.log('requestReceipt ok - ' + JSON.stringify(dadosFuncao));
    wait.close();

  }

  async dismemberOrder () {
    const orderData = await this._orderedService.geteOrderById("2V1SIqcFHgwovGn3BMlw") //  QpoqQsMkRcaZRAshR8Jn
    const order = orderData.data();
    // console.log(JSON.stringify(order));
    //
    const param = {"order": order}
    const requestReceipt = this.ff.httpsCallable('dismemberOrders');
    const dismembnerResult = await lastValueFrom(requestReceipt(param));
    console.log(JSON.stringify(dismembnerResult));
    //
  }

  async getSpeakersAgenda (key: string) {
    const waiting = this._spinnerService.show();
    const speakerAgenda = await this._publishService.getSpeakersAgenda(key);
    console.log("speakerAgenda: " + JSON.stringify(speakerAgenda))
    waiting.close();
  }

  async speakers () {
    const speakersPublished = await this._eventPublishService.getSpeakers()
    // console.log("speakersPublished: " + JSON.stringify(speakersPublished))
    speakersPublished.forEach((item) => {
      console.log("name: " + item.name);
      console.log("state: " + item.state);
      console.log("---------------------------------");
    })
  }

  getCountries () {
    const countries: any = []
    this._memberService.loadAll()
      .pipe(takeUntil(this.destroy$)) // Segurança para fechar o canal ao sair
      .subscribe(data => {
        this.members = data;
        console.log("ok ----------------- ");

        this.members.forEach((member) => {
          if (member.country) {
            const exist = countries.find((e) => {
              return e.country.toUpperCase() == member.country.toUpperCase()
            })
            if (!exist) {
              const c: string = member.country;
              countries.push(
                {
                  "country": c.toUpperCase(),
                  "flag": ""
                }
              )
            }
          }
        })
        countries.sort(this.compareNames);
        console.log(JSON.stringify(countries))
      });

  }

  compareNames (a, b) {
    if (a.country > b.country) return 1;
    if (b.country > a.country) return -1;
    return 0;
  }

  loadMembers () {
    this._memberService.loadAll()
      .pipe(takeUntil(this.destroy$)) // Segurança para fechar o canal ao sair
      .subscribe(data => {
        this.members = data;
        console.log("ok ----------------- ");
        this.members.forEach((member)=>{
          if(member.staff) {
            
          }

        })
      });

  }

  lookMembers () {
    this.members.forEach((item) => {
      if (item.name) {
        console.log("name: " + item.name);
        console.log("situation: " + item.situation);
        console.log("category: " + item.subCategory.name);
        console.log("partner: " + item.subCategory.partner);
        console.log("---------------------------------");
      }
    })

  }

  async getAllScheduledData () {
    try {
      const result = await this._eventPublishService.geteAllData();
      console.log("Dados recebidos:", JSON.stringify(result));

      // Aqui você pode manipular o 'result' à vontade
    } catch (error) {
      console.error("Erro ao carregar dados agendados:", error);
    }
  }


  async getAllSpeakers () {
    try {
      const result = await this._eventPublishService.getAllSpeakers();
      console.log("Dados recebidos:", JSON.stringify(result));

      // Aqui você pode manipular o 'result' à vontade
    } catch (error) {
      console.error("Erro ao carregar dados agendados:", error);
    }
  }


  loadTaviProfs () {
    const array = this.getData();
    array.forEach((item) => {
      this._sitePublicService.insertTaviCenter(item)
        .then((result) => {
          console.log(result.id)
          console.log(item.name)
        })
    })
  }

  getData () {
    return []
  }

  async getAuth () {
    const result = await this._authService.currentClaims()
    console.log(JSON.stringify(result.claims))
  }

  getPublishedCollection () {
    this._publishService.getPublishedCollection()
      .subscribe((result: any) => {
        let count = 0
        const array = [];
        result.forEach((item) => {
          array.push({id: item.id, ...item.data()})
          count++
        })
        console.log(count)
        console.log(JSON.stringify(array))
      })
  }

  async simulateWebhookAction () {
    const response = await this._webhookDevService.simulateWebhookAction();
    console.log("response: " + JSON.stringify(response))
  }

  crypto () {
    const email = "email.otero@gmail.com"
    this.data = this._cryptoV2Service.encryptData(email)
    console.log("data: " + this.data)

  }

  decrypto () {
    const email = this._cryptoV2Service.decryptData(this.data)
    console.log("email: " + email)
  }

  async listMembers () {
    this._memberService.select().subscribe((result) => {
      result.forEach((item) => {

      })
    })


  }

  async pix (customer: any) {
    const action = "lean/payments";
    const data = {
      "customer": customer.id,
      "cpfCnpj": customer.cpfCnpj,
      "billingType": "PIX",
      "value": 1000,
      "dueDate": new Date(),
      "externalReference": "1234567890",
    }

    const payload = {
      verb: "POST",
      action: action,
      data: data
    }

    const response = await this._webhookDevService.asaasAction(payload);
    console.log("response -----------------------------")
    console.log(JSON.stringify(response));

  }

  async boleto (customer: any) {
    const action = "lean/payments";
    const data = {
      "customer": customer.id,
      "cpfCnpj": customer.cpfCnpj,
      "billingType": "BOLETO",
      "value": 1000,
      "dueDate": new Date()
    }

    const payload = {
      verb: "POST",
      action: action,
      data: data
    }

    const response = await this._webhookDevService.asaasAction(payload);
    console.log("response -----------------------------")
    console.log(JSON.stringify(response));

  }

  async creditCard () {
    const action = "lean/payments";

    const data = {
      "customer": "cus_000006950631",
      "billingType": "CREDIT_CARD",
      "value": 1000,
      "totalValue": 1000,
      "installmentCount": 1,
      "dueDate": new Date(),
      "description": "sbccv",
      "externalReference": "", // campo livre para busca
      "creditCard": {
        "cardBrand": "Master",
        "holderName": "marcelo h almeida",
        "number": "5162306219378829",
        "expiryMonth": "05",
        "expiryYear": "2030",
        "ccv": "318"
      },
      "remoteIp": "116.213.42.532"
    }

    const payload = {
      verb: "POST",
      action: action,
      data: data
    }

    const response = await this._webhookDevService.asaasAction(payload);
    console.log("response -----------------------------")
    console.log(JSON.stringify(response));

    /*
          "creditCardHolderInfo": {
        "name": "Marcelo Henrique Almeida",
        "email": "marcelo.almeida@gmail.com",
        "cpfCnpj": "24971563792",
        "postalCode": "89223-005",
        "addressNumber": "277",
        "addressComplement": null,
        "phone": "4738010919",
        "mobilePhone": "47998781877"
      },
      */
  }

  async getClientByCpf () {

    const cpf = "85419127016";

    const action = "customers?cpfCnpj=" + cpf;

    const payload = {
      verb: "GET",
      action: action,
    }

    const response = await this._webhookDevService.asaasAction(payload);
    console.log(JSON.stringify(response))
    console.log("------------------------------------------------")

    if (response.totalCount > 0) {
      console.log("id: " + response.data[ 0 ].id)
      console.log("name: " + response.data[ 0 ].name)
      console.log("cpfCnpj: " + response.data[ 0 ].cpfCnpj)
      console.log("email: " + response.data[ 0 ].email)
      console.log("phone: " + response.data[ 0 ].phone)
    }
  }

  async getClientByName () {

    const name = "Abelardo Barbosa"; // (teste)

    const action = "customers?name=" + name;

    const payload = {
      verb: "GET",
      action: action,
    }

    const response = await this._asaasService.asaasAction(payload);
    console.log(JSON.stringify(response))
    console.log("------------------------------------------------")

    if (response.totalCount > 0) {
      console.log("id: " + response.data[ 0 ].id)
      console.log("name: " + response.data[ 0 ].name)
      console.log("cpfCnpj: " + response.data[ 0 ].cpfCnpj)
      console.log("email: " + response.data[ 0 ].email)
      console.log("phone: " + response.data[ 0 ].phone)
    } else {
      console.log("cliente não encontrado")
    }
  }

  async getClientByNameDev () {

    const name = "Abelardo Barbosa"; // (teste)

    const action = "customers?name=" + name;

    const payload = {
      verb: "GET",
      action: action,
    }

    const response = await this._webhookDevService.asaasAction(payload);
    console.log(JSON.stringify(response))
    console.log("------------------------------------------------")

    if (response.totalCount > 0) {
      console.log("id: " + response.data[ 0 ].id)
      console.log("name: " + response.data[ 0 ].name)
      console.log("cpfCnpj: " + response.data[ 0 ].cpfCnpj)
      console.log("email: " + response.data[ 0 ].email)
      console.log("phone: " + response.data[ 0 ].phone)
    }
  }

  async listClients () {

    const action = "customers";

    const payload = {
      verb: "GET",
      action: action,
    }

    const response = await this._webhookDevService.asaasAction(payload);
    console.log(JSON.stringify(response))

  }

  async checkClient () {

    const action = "customers/";

    const payload = {
      verb: "GET",
      action: action,
      data: "cus_000006950631"
    }

    const response = await this._webhookDevService.asaasAction(payload);
    if (response === 404) {
      console.log("cliente não encontrado")
    } else {
      console.log(JSON.stringify(response))
      this.client = {
        id: response.id,
        name: response.name,
        country: response.country,
        created: response.dateCreated,
      }
      console.log(JSON.stringify(this.client));
    }

  }

  createClient (media) {

  }

  async createClientDev (media) {

    const action = "customers";

    const data = {
      "name": "Abelardo Barbosa (teste)",
      "email": "carlos@otero.net.br",
      "cpfCnpj": "85419127016", // 
      "phone": "11999697174",
      "foreignCustomer": false,
      "country": "Brasil",
    }

    const payload = {
      verb: "POST",
      action: action,
      data: data
    }

    const response: any = await this._webhookDevService.asaasAction(payload);
    console.log("response -----------------------------")
    console.log(response);

    if (response == 400) {
      console.log("Dados Inválidos ao cadastrar cliente");
    } else {

      if (media === "boleto") {
        this.boleto(response)
      }

      if (media === "pix") {
        this.pix(response)
      }
    }

  }

  async testPaymentReceived () {
    try {
      const webhookUrl = 'https://us-central1-sbccv-proj.cloudfunctions.net/asaasWebhook'; // Substitua pela URL real
      await this._webhookDevService.testPaymentReceivedWebhook(webhookUrl);
      alert('Teste de PAYMENT_RECEIVED enviado com sucesso! Verifique os logs.');
    } catch (error) {
      alert('Erro ao testar webhook');
    }
  }

  async testPaymentConfirmed () {
    try {
      const webhookUrl = 'https://us-central1-sbccv-proj.cloudfunctions.net/asaasWebhook'; // Substitua pela URL real
      await this._webhookDevService.testPaymentConfirmedWebhook(webhookUrl);
      alert('Teste de PAYMENT_CONFIRMED enviado com sucesso! Verifique os logs.');
    } catch (error) {
      alert('Erro ao testar webhost');
    }
  }

  analizeLogs () {
    const array = this.loadLogs()
    array.forEach((item) => {
      console.log(item.textPayload);
      console.log(item.timestamp);
      console.log("---------------------------------");
    })

  }

  loadLogs () {
    return []
  }
}
